module.exports = __webpack_public_path__ + "static/media/hotel-1.09eeb4f6.jpg";